export default "__VITE_ASSET__44Ea7TgJ__"